import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintDashboard } from '.';

/**
 * @component {kat-blueprint-dashboard-overview} KatBlueprintDashboardOverview Component used to place and filter components within the overview section.
 * @slot default Blueprint content for overview section.
 */
@register(KatBlueprintDashboard.slotMapping.overview.name)
export class KatBlueprintDashboardOverview extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintDashboard.slotMapping.overview.name,
      KatBlueprintDashboard.slotMapping.overview.allowed
    );
  }
}
